import * as React from 'react';

import TwoPeople16 from './TwoPeople16';

export const twoPeople16 = () => <TwoPeople16 />;

export default {
    title: 'Icon/Fill/TwoPeople16',
    component: TwoPeople16,
    parameters: {
        notes: "`import TwoPeople16 from 'box-ui-elements/es/icon/fill/TwoPeople16';`",
    },
};
